<template>
  <v-row>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.accounts.retrieveLoader || !editable.name" transition="fade-transition" type="article"/>
      <template v-else>
        <v-card>
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información de la organización</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="end">
                <v-tooltip bottom transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-btn class="mr-6 font-weight-regular" @click="toClipboard(accountsDetail.id)" text color="secondary" v-on="on" :ripple="false">ID {{accountsDetail.id}}</v-btn>
                  </template>
                  <span>Copiar</span>
                </v-tooltip>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0 background">
            <v-row class="py-3">
              <v-col md="8">
                <v-list class="v-list-form transparent">
                  <v-list-item class="my-3">
                    <v-list-item-title>Nombre</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-text-field v-model="$v.editable.name.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line class="pa-0" dense placeholder="Acme LLC" maxlength="64" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>País</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-select v-model="editable.country.name" :items="[editable.country.name]" :item-text="editable.country.name" :item-value="editable.country.name" single-line disabled hide-details dense height="30" outlined background-color="white" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Estado</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-select v-model="$v.editable.state.$model" :error="$v.editable.state.$error" :items="statesList" item-text="name" item-value="id" hide-details single-line dense height="30" outlined background-color="white" no-data-text="No existen estados para el país." />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Dirección</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.editable.address.$model" :error="$v.editable.address.$error" background-color="white" outlined required single-line dense maxlength="128" hide-details />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="mt-6">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Información fiscal</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Número fiscal</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-text-field v-model="editable.tax_id" background-color="white" outlined required single-line dense disabled hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="mt-6">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Información de contacto</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Email</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-text-field v-model="$v.editable.email.$model" :error="$v.editable.email.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Teléfono</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-text-field v-model="$v.editable.phone.$model" :error="$v.editable.phone.$error" background-color="white" outlined required single-line dense v-mask="`${editable.country.phone_code} # #### ####`" maxlength="16" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Sitio web</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="10">
                        <v-text-field v-model="$v.editable.website.$model" :error="$v.editable.website.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="mt-6">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Programas Beta de Piriod</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="py-1">
                    <v-list-item-title>Funciones con acceso temprano</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-switch class="mt-n4" style="position:absolute" v-model="editable.early_access_features" />
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn @click="patchAccount" :loading="$store.state.accounts.createLoader" color="primary">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, minLength, maxLength, email, url } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    editable: {}
  }),
  computed: mapState({
    statesList: state => state.generals.statesList,
    accountsDetail: state => state.accounts.accountsDetail,
    activitiesList: state => state.generals.activitiesList
  }),
  created () {
    this.$store.dispatch('accounts/RETRIEVE', {
      resource: 'accounts',
      id: this.$store.state.auth.account.id
    })
    .then(() => {
      const account = cloneDeep(this.accountsDetail)
      this.editable = account
      this.$store.dispatch('generals/LIST', {
        resource: 'generals/states',
        query: {
          country__id: this.accountsDetail.country.id,
          page_size: 500
        }
      })
    })
  },
  methods: {
    patchAccount () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = {
        name: this.editable.name,
        state: this.editable.state.id || this.editable.state,
        address: this.editable.address,
        email: this.editable.email,
        phone: this.editable.phone,
        website: this.editable.website,
        early_access_features: this.editable.early_access_features
      }
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: payload,
        id: this.editable.id
      })
      .then(() => {
        this.$dialog.message.info('La información de la organización se ha actualizado')
      })
      .catch((error) => {
        this.$dialog.message.warning(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    editable: {
      name: {
        required,
        maxLength: maxLength(64)
      },
      state: {
        required
      },
      address: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(128)
      },
      email: {
        required,
        email,
        maxLength: maxLength(254)
      },
      phone: {
        maxLength: maxLength(16)
      },
      website: {
        url
      }
    }
  }
}
</script>